import {createRef} from 'react';

const ModalRef = createRef();

export default ModalRef;
